export default __webpack_public_path__ + "static/media/inspire.8f2b5c5f.jpg";